import { Entity, type EnemyConstruction } from "../Entity";

/** Authored melee enemy with the standard charge-and-slash sequence. */
export class MeleeEntity extends Entity {
  constructor(init: EnemyConstruction) {
    super(init);
  }

  override get meleeDamage(): number {
    return 20;
  }

  protected override slashAction(flipped: boolean): number {
    return flipped ? 3 : 2;
  }
}
